// generated by the plop

import { Injectable } from '@angular/core';
import { Selector, State } from '@ngxs/store';
import { AccessState, AccessStateModel, ProfileState, ProfileStateModel, UserModel } from 'shared';
import { PermissionEnum } from 'symbols';
import { FINANCE_ACCESS_DEFAULT, FinanceAccessModel } from './finance-access.model';

@State({ name: 'FinanceAccess' })
@Injectable()
export class FinanceAccessState {

  /**
   * Generate configs for classroom module depends on a provided user role.
   */
  static generateFinanceAccess(roles: PermissionEnum[], user: UserModel): FinanceAccessModel {
    // Return permissions as for an unknown role if user not verified or not authenticated.
    if (!user) {
      return this.generateRoleConfig(PermissionEnum.UNKNOWN);
    }

    // Apply permissions of each provided role.
    const rolesConfig: FinanceAccessModel[] = roles.map(role => this.generateRoleConfig(role));

    // Return defined config.
    return this.mergeConfig(rolesConfig);
  }

  /**
   * Define and create config using provided config data.
   */
  static generateRoleConfig(role: PermissionEnum): FinanceAccessModel {
    switch (role) {
      case PermissionEnum.CAN_READ_FINANCE_REGISTER:
        return {
          ...FINANCE_ACCESS_DEFAULT,
          canReadFinanceRegister: true
        };
      case PermissionEnum.CAN_CREATE_SCORES:
        return {
          ...FINANCE_ACCESS_DEFAULT,
          canCreateScores: true
        };

      case PermissionEnum.CAN_UPDATE_SCORES:
        return {
          ...FINANCE_ACCESS_DEFAULT,
          canUpdateScores: true
        };

      case PermissionEnum.CAN_REMOVE_SCORES:
        return {
          ...FINANCE_ACCESS_DEFAULT,
          canRemoveScores: true
        };
      case PermissionEnum.CAN_CREATE_CATEGORY:
        return {
          ...FINANCE_ACCESS_DEFAULT,
          canCreateCategory: true
        };
      case PermissionEnum.CAN_UPDATE_CATEGORY:
        return {
          ...FINANCE_ACCESS_DEFAULT,
          canUpdateCategory: true
        };
      case PermissionEnum.CAN_REMOVE_CATEGORY:
        return {
          ...FINANCE_ACCESS_DEFAULT,
          canRemoveCategory: true
        };

      case PermissionEnum.SUPER_USER:
        return {
          canReadFinanceRegister: true,
          canCreateScores: true,
          canRemoveScores: true,
          canUpdateScores: true,
          canCreateCategory: true,
          canRemoveCategory: true,
          canUpdateCategory: true
        };
      default: {
        return {
          ...FINANCE_ACCESS_DEFAULT
        };
      }
    }
  }

  /**
   * Merge provided roles configs (by union rule).
   */
  static mergeConfig(rolesConfig: FinanceAccessModel[]): FinanceAccessModel {
    const moduleConfig: FinanceAccessModel = FINANCE_ACCESS_DEFAULT;

    for (const config of rolesConfig) {
      moduleConfig.canCreateScores = moduleConfig.canCreateScores ? true : config.canCreateScores;
      moduleConfig.canReadFinanceRegister = moduleConfig.canReadFinanceRegister ? true : config.canReadFinanceRegister;
      moduleConfig.canRemoveCategory = moduleConfig.canRemoveCategory ? true : config.canRemoveCategory;
      moduleConfig.canUpdateCategory = moduleConfig.canUpdateCategory ? true : config.canUpdateCategory;
      moduleConfig.canUpdateScores = moduleConfig.canUpdateScores ? true : config.canUpdateScores;
      moduleConfig.canCreateCategory = moduleConfig.canCreateCategory ? true : config.canCreateCategory;
      moduleConfig.canRemoveScores = moduleConfig.canRemoveScores ? true : config.canRemoveScores;
    }

    return moduleConfig;
  }

  /**
   * Define and create module access rules using provided portal data.
   */
  @Selector([ProfileState, AccessState])
  static accessToFinance(profileState: ProfileStateModel, accessState: AccessStateModel): FinanceAccessModel {
    const userData = profileState.currentUser;
    const roleList = accessState.roles;

    return FinanceAccessState.generateFinanceAccess(roleList, userData);
  }

}


